import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { getReviewByIdQuery } from '../../../api/reviewsApi';
import { authenticatedRoute } from '../../../pages/AuthenticatedView.route';

export const reviewSummaryRoute = createRoute({
    getParentRoute: () => authenticatedRoute,
    path: "/reviews/$reviewId/overview",
    loader: ({ context, params }) => {
        return context.queryClient.prefetchQuery(getReviewByIdQuery(params.reviewId));
    },    
    component: lazyRouteComponent(() => import('./ReviewSummary.page'))
});